import { useEffect } from "react";
import { useNominatimLocation } from "../../hooks/locationHooks";
import { LocationResult, SelectedLocationState } from "../../types";
import { LocationSearchItem } from "./LocationSearchItem";

interface Props {
  query: string;
  onSelect: (result: LocationResult) => void;
  selected: SelectedLocationState;
  setSelected: (selected: SelectedLocationState) => void;
}

export function LocationSearchNominatim(props: Props) {
  const { query, onSelect, selected, setSelected } = props;
  const { data: results } = useNominatimLocation(query);

  useEffect(() => {
    const { length } = results || [];
    if (length !== selected.numItems)
      setSelected({ ...selected, numItems: results?.length || 0 });
  }, [results, selected, setSelected]);

  return (
    <>
      {results &&
        results.map((result, i) => (
          <LocationSearchItem
            key={result.id}
            item={result}
            index={i}
            onSelect={onSelect}
            selected={selected}
          />
        ))}
    </>
  );
}
